import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DefinicaoSenhaModel } from './definicao-senha.model';
import { UsuarioService } from '../../services/usuario/usuario.service';
import { Usuario } from '../../pages/usuarios/usuario.model';
import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';
@Component({
	selector: 'definicao-senha',
	templateUrl: './definicao-senha.component.html',
	styleUrls: ['./definicao-senha.component.scss']
})
export class DefinicaoSenhaComponent implements OnInit {

	style: any;
	login: DefinicaoSenhaModel;
	showMessages: boolean;
	errors: Array<any>;
	messages: Array<any>;
	submitted: boolean;
	usuario: Usuario;
	constructor(private auth: AuthService, private usuarioService: UsuarioService, private rota: ActivatedRoute, private router: Router) {
		this.style = {
			definicao: {
				"height": "100vh",
				"background-image": "linear-gradient(to left, #0095ff, #b4e0ff, #0095ff)"
			},
			loginBox: {
				"background-color": "rgba(255,255,255,0.85)"
			}
		}
		this.showMessages = false;
		this.errors = [];
		this.messages = [];
		this.login = new DefinicaoSenhaModel();
		this.usuario = new Usuario();
		this.rota.params.subscribe(params => {
			if (params['hash']){
				this.login.DefinicaoHash = params['hash'];
				this.carregar(this.login.DefinicaoHash);
			}
		});

		this.submitted = false;
	}

	ngOnInit() {
	}

	carregar(hash: string) {
		this.usuarioService.carregarHash(hash).subscribe(data => {
			if(data['Sucesso'])
				this.usuario = data['Retorno'] as Usuario;
			else
				this.router.navigate(['login']);
		});
	}
	definirSenha() {
		this.auth.definicaoSenha(this.login);
	}
}



// WEBPACK FOOTER //
// ./src/app/login/definicao-senha/definicao-senha.component.ts